module.exports = __webpack_public_path__ + "img/1-i-icon-language-eng.f6037dfc.svg";